import React from "react";
import { Button as MaterialButton } from "@material-ui/core";

const Button = ({className, disabled, onClick, RootButtonProps, children}) => {

  return (
    <MaterialButton
      className={[className, "text-bold"].join(" ")}
      onClick={onClick}
      disabled={disabled}
      {...RootButtonProps}
    >
      {children}
    </MaterialButton>
  )
};
export default Button;
